document.querySelectorAll('.faq-section').forEach(function (section) {
  var items = section.querySelectorAll('[data-faq-item]');

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-faq-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function (other) {
        other.classList.remove('is-open');
        var otherTrigger = other.querySelector('[data-faq-trigger]');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
